import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/img/icons/plus_white.svg';
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from '../../../styledComponents/buttons';
import {
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../../styledComponents/common';
import AddMasterSubTaskModal from './AddMasterSubTaskModal';
import MasterSubTasksFilter from './MasterSubTasksFilter';
import MasterSubTasksList from './MasterSubTasksList';


const MasterSubTasks = ({
  getMasterSubTasks,
  masterSubTasksList,
  editMasterSubTask,
  isLoading,
  getPublicZoneList,
  publicZoneList,
  officesShortList2,
  getOfficesShortList,
  officesShortList,
  addMasterSubTask,
  addTaskLoading,
  // New props for master tasks
  getMasterTasks,
  masterTasksList,
  masterTasksLoading,
}) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    publicZone: null,
    office: null,
    subTaskName: '',
    subTaskCode: '',
  });
  const [reload, setReload] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  // Add a function to handle the API call for adding/editing subtasks with "All Offices" support
  const handleAddOrEditMasterSubTask = (payload) => {
    if (isEditMode && taskToEdit) {
      // For editing an existing subtask
      editMasterSubTask({
        ...payload,
        task_id: taskToEdit.id,
        callback: () => {
          toggleModal();
          setReload(!reload);
        },
      });
    } else {
      // For adding a new subtask
      addMasterSubTask({
        ...payload,
        callback: () => {
          toggleModal();
          setReload(!reload);
        },
      });
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      // Reset edit mode and task when modal is closed
      setIsEditMode(false);
      setTaskToEdit(null);
    }
  };

  const handleEditTask = task => {
    setTaskToEdit(task);
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  useEffect(() => {
    getPublicZoneList();
  }, [getPublicZoneList]);

  useEffect(() => {
    const payload = {};
    if (filters?.publicZone?.value) {
      payload.public_zone_id = filters.publicZone.value;
    }
    if (filters?.office?.value) {
      payload.office_id = filters.office.value;
    }
    if (filters?.subTaskName) {
      payload.name = filters.subTaskName;
    }
    if (filters?.subTaskCode) {
      payload.code = filters.subTaskCode;
    }

    getMasterSubTasks(payload);
  }, [getMasterSubTasks, filters, reload]);

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('master_sub_tasks')}</PageTitle>
        <ColoredButtonWithIcon
          onClick={() => {
            setIsEditMode(false);
            setTaskToEdit(null);
            toggleModal();
          }}
        >
          <ButtonIcon src={plusIcon} alt="" />
          {t('create_subtask')}
        </ColoredButtonWithIcon>
      </CommonGrid>
      <HeaderContainer>
        <MasterSubTasksFilter
          publicZoneList={publicZoneList}
          getOfficesShortList={getOfficesShortList}
          officesShortList={officesShortList}
          handleSearchByName={() => {}}
          handleClearSearch={() => {}}
          onFilterChange={setFilters}
        />
      </HeaderContainer>
      <MasterSubTasksList
        masterSubTasksList={masterSubTasksList}
        editMasterSubTask={handleEditTask}
        isLoading={isLoading}
        publicZoneList={publicZoneList}
      />

      <AddMasterSubTaskModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        publicZoneList={publicZoneList}
        officesShortList={officesShortList2}
        getOfficesShortList={params =>
          getOfficesShortList({ ...params, secondApi: true })
        }
        addMasterSubTask={handleAddOrEditMasterSubTask}
        isLoading={addTaskLoading}
        editMasterSubTask={handleAddOrEditMasterSubTask}
        reload={reload}
        setReload={setReload}
        isEditMode={isEditMode}
        taskToEdit={taskToEdit}
        // Pass master tasks props
        getMasterTasks={getMasterTasks}
        masterTasks={masterTasksList}
        masterTasksLoading={masterTasksLoading}
      />
    </div>
  );
};

export default MasterSubTasks;
